module.exports = __webpack_public_path__ + "static/media/empty_cart.49edaf61.svg";